import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-716c6bff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute justify-end flex w-full mt-3 pr-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    class: "p-icon p-dropdown-trigger-icon",
    "aria-hidden": "true",
    "data-pc-section": "dropdownicon"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
      fill: "#71717A"
    })
  ])
], -1))
const _hoisted_3 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "2",
  width: "16",
  height: "16",
  rx: "4",
  fill: "#0090BE"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6 10.5L9 13.5L14 8.5",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "2",
  width: "16",
  height: "16",
  rx: "4",
  fill: "#fff",
  stroke: "#d1d5db",
  "stroke-width": "2"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_12 = { class: "ggms-multiselect-option-row flex items-center gap-2" }
const _hoisted_13 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "2",
  width: "16",
  height: "16",
  rx: "4",
  fill: "#0090BE"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6 10.5L9 13.5L14 8.5",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "2",
  width: "16",
  height: "16",
  rx: "4",
  fill: "#fff",
  stroke: "#d1d5db",
  "stroke-width": "2"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}

import "vue-multiselect/dist/vue-multiselect.css"
import { computed, ref, watch, onMounted } from "vue"
import MultiSelect from "vue-multiselect"
import GgmsChip from "@/components/GgmsChip.vue"
import { useTagStore } from "@/stores/tag"
import { useOriginStore } from "@/stores/origin"

interface Props {
    modelValue: any[]
    options: any[]
    display?: "comma" | "chip"
    label?: string
    optionLabel?: string
    optionValue?: string
    placeholder?: string
    isShowClear?: boolean
    classes?: string
    errorMessage?: string
    invalid?: boolean
    disabled?: boolean
    emptyMessage?: string
    maxSelectedLabels?: number
    openDirection?: "above" | "below"
    maxHeight?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsMultiSelect',
  props: {
    modelValue: {},
    options: {},
    display: { default: "comma" },
    label: {},
    optionLabel: { default: "displayName" },
    optionValue: { default: "_id" },
    placeholder: { default: "Select Element" },
    isShowClear: { type: Boolean },
    classes: {},
    errorMessage: {},
    invalid: { type: Boolean },
    disabled: { type: Boolean },
    emptyMessage: {},
    maxSelectedLabels: { default: 3 },
    openDirection: {},
    maxHeight: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const localModelValue = ref<any[]>(props.modelValue || [])

watch(
    () => props.modelValue,
    (newValue) => {
        localModelValue.value = newValue || []
    }
)

watch(
    localModelValue,
    (newValue) => {
        emit("update:modelValue", newValue)
        emit("change", newValue)
    },
    { deep: true }
)

const localErrorMessage = ref(props.errorMessage)
const localInvalid = ref(props.invalid)

const errorStyle = computed(() => (localInvalid.value ? "error-style" : ""))

const isChipDisplay = computed(() => props.display === "chip")

const localDisabled = computed(() => props.disabled || !props.options?.length)

const tagStore = useTagStore()
const originStore = useOriginStore()
const cachedTags = computed(() => tagStore.cachedTags)
const cachedOrigins = computed(() => originStore.cachedOrigins)

const trackBy = computed(() => props.optionValue || "_id")
const optionLabel = computed(() => props.optionLabel || "displayName")

function getBgColor(option: any): string {
    return cachedTags.value[option._id]?.backgroundColor || cachedOrigins.value[option._id]?.backgroundColor
}

function getTextColor(option: any): string {
    return cachedTags.value[option._id]?.foregroundColor || cachedOrigins.value[option._id]?.foregroundColor
}

function onInput(value: any[]) {
    localModelValue.value = value
}

watch(
    () => props.errorMessage,
    (value) => {
        localErrorMessage.value = value
    }
)

watch(
    () => props.invalid,
    (value) => {
        localInvalid.value = value
    }
)

const isEmpty = computed(() => !props.options.length)

onMounted(() => {
    localInvalid.value = false
    localErrorMessage.value = ""
})

// Helper to check if an option is selected
function isOptionSelected(option: any): boolean {
    return localModelValue.value.some((selected: any) => selected[trackBy.value] === option[trackBy.value])
}

// Helper to check if all options are selected
const isAllSelected = computed(() => {
    if (!props.options?.length) return false
    return (
        localModelValue.value.length === props.options.length &&
        props.options.every((opt) => localModelValue.value.some((sel) => sel[trackBy.value] === opt[trackBy.value]))
    )
})

// Toggle all selection
function toggleAll() {
    if (isAllSelected.value) {
        localModelValue.value = []
    } else {
        localModelValue.value = [...props.options]
    }
}

// Utility function to resolve nested property by path (e.g., 'smth.label')
/**
 * Resolves a nested property from an object using a dot-separated path string.
 * @param obj The object to resolve from.
 * @param path The dot-separated path string (e.g., 'smth.label').
 * @returns The resolved value or undefined if not found.
 */
function resolveLabel(obj: any, path: string): any {
    if (!obj || !path) return undefined
    return path.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.classes, "flex flex-col"])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.classes, "relative"])
    }, [
      _createVNode(_unref(MultiSelect), {
        modelValue: localModelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModelValue).value = $event)),
        options: _ctx.options,
        multiple: true,
        taggable: false,
        "track-by": trackBy.value,
        label: optionLabel.value,
        placeholder: isEmpty.value ? 'No options available' : _ctx.placeholder,
        disabled: localDisabled.value,
        searchable: false,
        "hide-selected": false,
        "show-labels": true,
        "close-on-select": false,
        class: "ggms-multiselect",
        onInput: onInput,
        "open-direction": _ctx.openDirection,
        "max-height": _ctx.maxHeight
      }, {
        caret: _withCtx(() => [
          _hoisted_2
        ]),
        beforeList: _withCtx(() => [
          _createElementVNode("div", {
            class: "flex items-center gap-2 py-2 px-3 cursor-pointer select-none",
            onClick: toggleAll
          }, [
            _createElementVNode("span", null, [
              (isAllSelected.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6))
                : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
            ]),
            _createElementVNode("span", _hoisted_10, _toDisplayString(isAllSelected.value ? "Deselect All" : "Select All"), 1)
          ])
        ]),
        tag: _withCtx(({ option, remove }) => [
          (isChipDisplay.value)
            ? (_openBlock(), _createBlock(GgmsChip, {
                key: 0,
                bgColor: getBgColor(option),
                textColor: getTextColor(option),
                class: "mr-2",
                onOnRemove: ($event: any) => (remove(option))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(resolveLabel(option, optionLabel.value)), 1)
                ]),
                _: 2
              }, 1032, ["bgColor", "textColor", "onOnRemove"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(resolveLabel(option, optionLabel.value)), 1))
        ]),
        option: _withCtx(({ option }) => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", null, [
              (isOptionSelected(option))
                ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_16))
                : (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
            ]),
            (isChipDisplay.value)
              ? (_openBlock(), _createBlock(GgmsChip, {
                  key: 0,
                  bgColor: getBgColor(option),
                  textColor: getTextColor(option),
                  isRemovable: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(resolveLabel(option, optionLabel.value)), 1)
                  ]),
                  _: 2
                }, 1032, ["bgColor", "textColor"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(resolveLabel(option, optionLabel.value)), 1))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "options", "track-by", "label", "placeholder", "disabled", "open-direction", "max-height"]),
      (localErrorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(localErrorMessage.value), 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})